/**
 * useSlippage — slippage tolerance state backed by localStorage.
 *
 * Persists the user's chosen slippage (in bps) so it survives page
 * reloads. Falls back to 50 bps (0.5%) if nothing is stored.
 */

import { useState, useCallback } from "react";

const STORAGE_KEY = "asic-slippage-bps";
const DEFAULT_BPS = 50;

function loadSlippage(): number {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return DEFAULT_BPS;
    const n = parseInt(raw, 10);
    if (isNaN(n) || n < 0 || n > 5000) return DEFAULT_BPS;
    return n;
  } catch {
    return DEFAULT_BPS;
  }
}

export function useSlippage() {
  const [bps, setBpsState] = useState(loadSlippage);

  const setBps = useCallback((next: number) => {
    setBpsState(next);
    try {
      localStorage.setItem(STORAGE_KEY, String(next));
    } catch {
      // ignore
    }
  }, []);

  return [bps, setBps] as const;
}
